import { Injectable } from '@angular/core';
import { ResponseStudentProgram } from '../models/sgpb.model';

@Injectable({
  providedIn: 'root'
})
export default class StudentUtils {

  /**
   * Orders the student program arrays by schoolTermGradingPeriodId
   * to ensure proper index alignment throughout the application
   * @param studentsData Array of student data to be sorted
   * @returns The same array with sorted internal arrays
   */
  orderStudentProgramArrays(studentsData: ResponseStudentProgram[]): ResponseStudentProgram[] {
    if (!studentsData || studentsData.length === 0) return studentsData;

    for (let student of studentsData) {
      // Sort the main student program array
      if (student.objStudentProgram && student.objStudentProgram.length > 0) {
        student.objStudentProgram.sort((a, b) => {
          const aId = parseInt(a.schoolTermGradingPeriodID);
          const bId = parseInt(b.schoolTermGradingPeriodID);
          return aId - bId;
        });
      }

      // Sort the past student program array
      if (student.objPastStudentProgram && student.objPastStudentProgram.length > 0) {
        student.objPastStudentProgram.sort((a, b) => {
          const aId = parseInt(a.schoolTermGradingPeriodID);
          const bId = parseInt(b.schoolTermGradingPeriodID);
          return aId - bId;
        });
      }

      // Sort the grading period array inside objGradingPeriods
      if (student.objGradingPeriods &&
        student.objGradingPeriods.grading_period &&
        student.objGradingPeriods.grading_period.length > 0) {
        student.objGradingPeriods.grading_period.sort((a, b) => {
          const aId = parseInt(a.schoolTermGradingPeriodId);
          const bId = parseInt(b.schoolTermGradingPeriodId);
          return aId - bId;
        });
      }
    }

    return studentsData;
  }

  /**
   * Safely gets a student program at a specific index
   * @param student Student object
   * @param index Index to access
   * @returns The student program at the index or null if not found
   */
  getStudentProgramAtIndex(student: ResponseStudentProgram, index: number) {
    if (student && student.objStudentProgram &&
      index >= 0 && index < student.objStudentProgram.length) {
      return student.objStudentProgram[index];
    }
    return null;
  }
}